/*  ========================================================================
    # Scripts - Event Dates
    ========================================================================  */

import { animate } from 'motion';

/**
 * Script to collapsabil event dates at the bottom of the event page
 */

const EventDates = {
  cfg: {
    list: document.querySelectorAll('.p-event__dates-list--closable'),
    paginationButton: document.querySelectorAll('.p-event__pagination-button')
  },

  handlePaginationButton() {
    this.cfg.paginationButton.forEach(button => {
      const list = this.cfg.list[0];
      button.addEventListener('click', () => {
        animate(list, {
          height: 'auto'
        });

        animate(button, {
          opacity: 0,
          visibility: 'hidden'
        });
      });
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.list) {
      this.handlePaginationButton();
    }
  }
};

export default EventDates;
